import cloneDeep from 'lodash/cloneDeep';
import uuid from 'uuid/v1';
import { getValueByPath, setValueByPath } from '../utils';
import { getUrlParam } from '../utils/url';

class GlobalModel {
    constructor() {
        // 表单数据
        this.formData = {};
        // 表单组件models键值对
        this.componentModels = {};
        // 全局参数
        this.globalParams = null;
        // 全局表单数据
        this.globalFormData = null;
        // 是否是b端编辑态
        this.isEdit = false;
        // 是否开启预览
        this.preview = false;
        // 是否是表单类型公告预览
        this.noticeFormPreview = false;
        // 提交样式是否隐藏
        this.hideSubmitStyle = false;
        // 错误数据
        this.errorData = [];
        // 四期字段级驳回灰度
        this.fieldReview = 0;
        // 视图类型（初始化时从 URL 获取，后续可通过 prop 覆盖）
        this.viewType = Number(getUrlParam('viewType')) || 0;
    }

    // 设置全局参数
    setGlobalParams(params) {
        this.globalParams = cloneDeep(params);
    }

    // 设置全局表单数据
    setGlobalFormData(params) {
        this.globalFormData = cloneDeep(params);
    }

    setIsEdit(isEdit) {
        this.isEdit = isEdit;
    }

    // 设置是否开启预览
    setPreview(preview) {
        this.preview = preview;
    }

    // 设置是否是表单类型公告预览
    setNoticeFormPreview(noticeFormPreview) {
        this.noticeFormPreview = noticeFormPreview;
    }

    // 设置提交按钮是否隐藏
    setHideSubmitStyle(hideSubmitStyle) {
        this.hideSubmitStyle = hideSubmitStyle;
    }

    setViewType(viewType) {
        this.viewType = viewType;
    }

    // 在全局model中注册组件
    registerComponent({ id, vm }) {
        if (!id) {
            id = uuid();
        }
        this.componentModels[id] = vm;
    }

    // 在全局model中删除组件
    deregisterComponent(deletedUuid) {
        delete this.componentModels[deletedUuid];
    }

    // 根据组件id获取可以获得的数据
    getValueById(id, path) {
        if (this.componentModels[id]) {
            const componentModel = this.componentModels[id];
            // 组件ID存在
            if (path === 'value') {
                // 读取组件对应的值
                return this.getFormDataValueByPath(componentModel.outputPath);
            }
            // 读取组件props中的值
            return this.getConfigPropsValueByPath(componentModel.config, path);

        }
        console.error('Function getValueById requires id');
        // eslint-disable-next-line
        return undefined;
    }

    setErrorData(val) {
        this.errorData = val;
    }

    setFieldReview(val) {
        this.fieldReview = val;
    }

    // 根据组件id获取键值对
    getKeyValueById(id) {
        const obj = {};
        if (this.componentModels[id]) {
            // 组件ID存在
            const componentModel = this.componentModels[id];
            setValueByPath(
                obj,
                componentModel.outputPath,
                this.getFormDataValueByPath(componentModel.outputPath),
                false
            );
            return obj;
        }
        return obj;
    }
    // 根据输出路径获取全局数据中的某值
    getFormDataValueByPath(outputPath) {
        return getValueByPath(this.formData, outputPath);
    }

    // 根据输出路径获取config.props的值
    getConfigPropsValueByPath(config, outputPath) {
        return getValueByPath(config.props, outputPath);
    }

    // 根据输出路径设置全局数据的值
    setFormDataValueByPath(outputPath, value) {
        // 这里需要先做是否输出到根的判断
        if (outputPath) {
            return setValueByPath(this.formData, outputPath, value, true);
        }
        this.formData = value || {};
        return true;
    }

    // 根据输出路径设置config.props的值
    setConfigPropsValueByPath(config, outputPath, value) {
        // 是否输出到根的判断
        if (outputPath) {
            return setValueByPath(config.props, outputPath, value, true);
        }
        config.props = value || {};
        return true;
    }
}

export default GlobalModel;
